import * as React from "react";
import { Field } from "redux-form";

import { TextArea } from "../../../components";
import { ProjectInfoFormProps } from "./ProjectInfoForm";

const ContentField = (props: ProjectInfoFormProps) =>
  <div className="form-group">
    <label className="control-label col-md-4">
      Nội dung
      <p className="help-block">
        Bạn hãy gõ chi tiết nội dung chữ sẽ xuất hiện trong thiết kế
      </p>
    </label>

    <div className="col-md-8">
      <Field
        className="form-control"
        name="content"
        component={TextArea}
        placeholder="Write something cool!"
        rows={5}
      />
    </div>
  </div>;
export default ContentField;



// WEBPACK FOOTER //
// ./src/routes/Step4/components/ContentField.tsx